import React from 'react';

const Clock: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9997 3.6665C8.10864 3.6665 3.33301 8.44213 3.33301 14.3332C3.33301 20.2242 8.10864 24.9998 13.9997 24.9998C19.8907 24.9998 24.6663 20.2242 24.6663 14.3332C24.6663 8.44213 19.8907 3.6665 13.9997 3.6665ZM1.33301 14.3332C1.33301 7.33756 7.00407 1.6665 13.9997 1.6665C20.9953 1.6665 26.6663 7.33756 26.6663 14.3332C26.6663 21.3288 20.9953 26.9998 13.9997 26.9998C7.00407 26.9998 1.33301 21.3288 1.33301 14.3332Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 6.33325C14.5523 6.33325 15 6.78097 15 7.33325V13.7152L19.1139 15.7722C19.6079 16.0191 19.8081 16.6198 19.5611 17.1138C19.3141 17.6078 18.7134 17.808 18.2195 17.561L13.5528 15.2277C13.214 15.0583 13 14.712 13 14.3333V7.33325C13 6.78097 13.4477 6.33325 14 6.33325Z"
      />
    </svg>
  );
};

export default Clock;
